'use strict';

import { fnToastrFormError, pjaxRefreshPage, printResponse } from "../jquery-functions-library";
import { element_exists } from "../functions";

export var fnUnlockPayroll = function () {

    var elementName = '#selected_payroll';

    $.ajaxSetup({ headers: { 'X-CSRF-TOKEN': $('[name="_token"]').val() } });

    if (!element_exists(elementName)) return false;

    var btnApprove = $('#btn-unlock-payroll');
    var countdown = $('#btn-unlock-payroll .btn-countdown');

    var timeSinceApproval = btnApprove.data('time-left');
    var timeLeft = 60 - timeSinceApproval;

    countdown.text(timeLeft);

    setInterval(function () {
        timeLeft--;
        countdown.text(timeLeft);
    }, 60000);

    var lang = allLangFiles.payrolls.unlock;

    btnApprove.on('click', function (e) {
        e.preventDefault();

        var url = $(this).attr('data-href');

        console.log(lang);

        $.confirm({
            title: lang.title,
            content: lang.confirm,
            theme: 'supervan',
            columnClass: 'col-md-12',
            backgroundDismiss: true,
            buttons: {
                Ja: {
                    action: function () {

                        $.ajax({
                            url: url,
                            success: function (response) {
                                $('')

                                printResponse(response);
                                console.log(response);
                                pjaxRefreshPage();
                            },
                            error: fnToastrFormError,
                        });
                    },
                    text: lang.yes
                },
                Nej: {
                    text: lang.no
                }
            }
        });
    });
};
